import { ANSWERS, PILOT_TAGS, RESOURCEdb } from '@wellbeingxltd/fe-lib/constants'

const {
    PILLARS: { SLEEP, EXERCISE, NUTRITION, OCCUPATION, STRESS, COMMUNITY },
    WELLBEINGATWORK: { POSITIVE, SATISFACTION },
} = RESOURCEdb

export const PILLARS = [
    { id: 0, text: SLEEP, nextQuestion: 1 },
    { id: 1, text: EXERCISE, nextQuestion: 1 },
    { id: 2, text: NUTRITION, nextQuestion: 1 },
    { id: 3, text: COMMUNITY, nextQuestion: 1 },
    { id: 4, text: OCCUPATION, nextQuestion: 1 },
    { id: 5, text: STRESS, nextQuestion: 1 },
]

const PILLAR_ANSWERS = [
    { id: 0, text: 0, nextQuestion: 1 },
    { id: 1, text: 1, nextQuestion: 1 },
    { id: 2, text: 2, nextQuestion: 1 },
    { id: 3, text: 3, nextQuestion: 1 },
    { id: 4, text: 4, nextQuestion: 1 },
    { id: 5, text: 5, nextQuestion: 1 },
    { id: 6, text: 6, nextQuestion: 1 },
    { id: 7, text: 7, nextQuestion: 1 },
    { id: 8, text: 8, nextQuestion: 1 },
    { id: 9, text: 9, nextQuestion: 1 },
    { id: 10, text: 10, nextQuestion: 1 },
]

const QUESTIONS = {
    HELLO: 'Before we get to all the benefits, let’s learn a little about you.\n\nWe’ll go through the six main contributors of wellbeing. It will take around 5 minutes and will help us personalise your journey.\n\nLet’s get started!',
    SLEEP_1: "Do you feel like you're getting enough good quality sleep?",
    SLEEP_2:
        "Sleep is important in so many ways…\n\nGood sleep helps with everything from increased energy and improved concentration, to reducing stress and helping our immune systems function better. Our sleep needs can change over time and we tend to take it for granted until there's a problem.\n\nUnderstanding how to get enough good quality sleep is fundamental to improving wellbeing.",
    EXERCISE_1: "Do you feel like you're getting enough exercise?",
    EXERCISE_2:
        'Our bodies are designed to move, and they become unhappy if we are too sedentary. As well as being important for our bodies, it turns out our brains love it too! It is one of the most effective treatments for low mood and depression, as well as helping reduce anxiety and improve sleep.\n\nJust 10 minutes can boost your mood, reduce fatigue, and help you manage chronic pain better. It can even stop chocolate cravings!\n\nWith so many different forms of exercise on offer, Betterspace is here to help you find the right one for you and make it a habit you can stick with.',
    NUTRITION_1: "Do you feel like you're eating a healthy, balanced diet?",
    NUTRITION_2:
        'Good quality nutrition is increasingly recognised as a crucial factor in mental health.\n\nNutritional deficiencies and poor-quality nutrition can both have a detrimental effect, and improved diet and nutritional supplementation may be as effective as some traditional treatments.',
    OCCUPATION_1: 'Do you feel you spend enough time doing meaningful activities, from hobbies to learning new skills?',
    OCCUPATION_2:
        'Activities that feel worthwhile or satisfying have a significant impact on our wellbeing.\n\nBy contributing to our feeling of purpose, or helping us develop a sense of mastery, they act as an antidote to overthinking and protect against low mood and anxiety. They are often the most overlooked ingredients of good wellbeing.',
    STRESS_1: 'Do you feel like you manage stress well?',
    STRESS_2:
        'Stress is an inevitable part of modern life.\n\nIt is our body’s response to any demand or threat. Short-term, it can be exciting, motivating and push us to produce our best performance. However, chronic and overwhelming stress causes mental and physical ill-health.\n\nIt’s when we feel overwhelmed and out of control that it begins to impact our wellbeing, and we seek out coping mechanisms.',
    COMMUNITY_1: "Do you feel you help other people as much as you'd like to and have enough regular social connections?",
    COMMUNITY_2:
        'Two of the most consistent factors relating to emotional well-being are connection to, and acts of service for, other people.\n\nWhilst we all know that helping other people and contributing to causes you care about has a positive effect on the recipient, what is less understood is the positive impact it has on you!\n\nIt reinforces our sense of affiliation with others, increases feelings of purpose, combats sadness and helps stop troubling rumination, which is so often the cause of unhappiness and anxiety.',
    SATISFACTION: 'Overall, how satisfied are you with your life nowadays?',
    POSITIVE: {
        default: 'Do you feel your employment is positively impacting your wellbeing?',
        [PILOT_TAGS.STUDENTS]: 'Do you feel the course you are studying positively impacts your wellbeing?',
        [PILOT_TAGS.ACCENTURE]: 'Do you feel there’s a senior person at work who genuinely cares about your wellbeing?',
        [PILOT_TAGS.LINKLATERS]: 'Do you feel your experience at Linklaters is positively impacting your wellbeing?',
    },
}

export const createAssessmentTemplate = ({ pilotTag = '', pillarsGoals }) => ({
    assessment: [
        {
            question: { id: 0, text: QUESTIONS.HELLO },
            answerType: ANSWERS.CONTINUE_BUTTON,
            answers: [{ id: 0, text: 'Get started', nextQuestion: 1 }],
            label: 'Hello',
            title: 'Hello',
        },
        {
            question: { id: 1, text: QUESTIONS.SLEEP_1 },
            answerType: ANSWERS.LIKERT_NUMBER,
            answersLabel: ['not at all', 'completely'],
            answers: PILLAR_ANSWERS,
            label: SLEEP,
            colour: SLEEP,
        },
        {
            question: { id: 2, text: QUESTIONS.SLEEP_2 },
            answerType: ANSWERS.CONTINUE_BUTTON,
            answers: [{ id: 0, text: 'Next page', nextQuestion: 1 }],
            label: SLEEP,
            colour: SLEEP,
        },
        {
            question: { id: 3, text: QUESTIONS.EXERCISE_1 },
            answerType: ANSWERS.LIKERT_NUMBER,
            answersLabel: ['not at all', 'completely'],
            answers: PILLAR_ANSWERS,
            label: EXERCISE,
            colour: EXERCISE,
        },
        {
            question: { id: 4, text: QUESTIONS.EXERCISE_2 },
            answerType: ANSWERS.CONTINUE_BUTTON,
            answers: [{ id: 0, text: 'Next page', nextQuestion: 1 }],
            label: EXERCISE,
            colour: EXERCISE,
        },
        {
            question: { id: 5, text: QUESTIONS.NUTRITION_1 },
            answerType: ANSWERS.LIKERT_NUMBER,
            answersLabel: ['not at all', 'completely'],
            answers: PILLAR_ANSWERS,
            label: NUTRITION,
            colour: NUTRITION,
        },
        {
            question: { id: 6, text: QUESTIONS.NUTRITION_2 },
            answerType: ANSWERS.CONTINUE_BUTTON,
            answers: [{ id: 0, text: 'Next page', nextQuestion: 1 }],
            label: NUTRITION,
            colour: NUTRITION,
        },
        {
            question: { id: 7, text: QUESTIONS.COMMUNITY_1 },
            answersLabel: ['not at all', 'completely'],
            answerType: ANSWERS.LIKERT_NUMBER,
            answers: PILLAR_ANSWERS,
            label: COMMUNITY,
            colour: COMMUNITY,
        },
        {
            question: { id: 8, text: QUESTIONS.COMMUNITY_2 },
            answerType: ANSWERS.CONTINUE_BUTTON,
            answers: [{ id: 0, text: 'Next page', nextQuestion: 1 }],
            label: COMMUNITY,
            colour: COMMUNITY,
        },
        {
            question: { id: 9, text: QUESTIONS.OCCUPATION_1 },
            answersLabel: ['not at all', 'completely'],
            answerType: ANSWERS.LIKERT_NUMBER,
            answers: PILLAR_ANSWERS,
            label: OCCUPATION,
            colour: OCCUPATION,
        },
        {
            question: { id: 10, text: QUESTIONS.OCCUPATION_2 },
            answerType: ANSWERS.CONTINUE_BUTTON,
            answers: [{ id: 0, text: 'Next page', nextQuestion: 1 }],
            label: OCCUPATION,
            colour: OCCUPATION,
        },
        {
            question: { id: 11, text: QUESTIONS.STRESS_1 },
            answersLabel: ['not at all', 'completely'],
            answerType: ANSWERS.LIKERT_NUMBER,
            answers: PILLAR_ANSWERS,
            label: STRESS,
            colour: STRESS,
        },
        {
            question: { id: 12, text: QUESTIONS.STRESS_2 },
            answerType: ANSWERS.CONTINUE_BUTTON,
            answers: [{ id: 0, text: 'Next page', nextQuestion: 1 }],
            label: STRESS,
            colour: STRESS,
        },
        {
            question: { id: 13, text: '' },
            label: 'FindYourFirstGoal',
            answerType: ANSWERS.PILLAR_LIST,
            answers: PILLARS,
        },
        {
            question: { id: 14, text: '' }, // Leave this blank
            answerType: ANSWERS.PILLAR_GOALS,
            answers: pillarsGoals,
            nextQuestion: 1,
            label: '',
        },
        {
            question: { id: 15, text: '' },
            answerType: ANSWERS.CONTINUE_BUTTON,
            answers: [{ id: 0, text: 'Continue', nextQuestion: 1 }],
            image: 'flowers',
            label: 'LetsExploreWithPillars',
        },
        {
            question: { id: 16, text: QUESTIONS.SATISFACTION },
            answersLabel: ['not at all', 'completely'],
            answerType: ANSWERS.LIKERT_NUMBER,
            answers: PILLAR_ANSWERS,
            label: SATISFACTION,
            colour: SATISFACTION,
        },
        {
            question: { id: 17, text: QUESTIONS.POSITIVE[pilotTag] || QUESTIONS.POSITIVE.default },
            answerType: ANSWERS.LIKERT_NUMBER,
            answersLabel: ['not at all', 'completely'],
            answers: PILLAR_ANSWERS,
            label: POSITIVE,
            colour: POSITIVE,
        },
        {
            question: { id: 18, text: '' },
            label: 'Summary',
            answerType: ANSWERS.SUMMARY,
            answers: [{ id: 0, text: 'Submit', nextQuestion: 'end' }],
        },
    ],
})

const assessment = {
    version: '1.5',
    date: '21 Mar 2022',
    index: '-1',
}

export default assessment
